<template>
    <div class="carbonyl">
        <img
            src="@/assets/img/gruppen/carbonyl/carbonyl.png"
            alt="Die Carbonylgruppe"
            title="Die Carbonylgruppe"
            width="128px"
            height="auto"
        />
    </div>
</template>

<script>
export default {
    name: 'carbonyl',
};
</script>
